export default "__VITE_ASSET__zCn8P3fY__"